import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class UserActionsRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return this.store.find("user", params.id)
  }
}
